import React from "react"
import { Row, Table, Select } from "antd"
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"
import PButton from "app/components/normal/PButton"
import cancelIcon from "app/styles/images/sp/cancel.svg"
import deleteWarningIcon from "app/styles/images/sp/delete-warning.svg"
import { observer } from "mobx-react"
import "./shareModal.scss"

const { Option } = Select

@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      username: "",
      cancelShareModal: false,
      groupId:'', 
      toId:'',
    }
  }

  shareInputChange = (e) => {
    this.setState({
      username: e
    })
  }

  clearUsername = () => {
    this.setState({
      username: ""
    })
  }

  componentDidMount() {
    const { store: { getShareList }, data } = this.props
    getShareList(data.groupId)
  }

    closeModal = (modal) => {
      this.setState({
        [modal]: false
      })
    }
    showModal = (field,groupId,toId) => {
      this.setState({
        [field]: true,
        toId,
        groupId,
      })
    }
  render() {
    const { visible, action, onCancel, store: { shareList,cancelShare } } = this.props
    const { username,cancelShareModal,toId,groupId} = this.state
    const columns = [
      {
        title: "共享用户",
        dataIndex: "name",
        width: 100,
      }, {
        title: (<div className="ta-c">共享时间</div>),
        dataIndex: "shareTime",
        width: 300,
        render: (text) => (
          <div className="ta-c">{text}</div>
        )
      }, {
        title: (<div className="ta-c">操作</div>),
        dataIndex: "operate",
        width: 50,
        render: (text, record, index) => (
          
          <div className="ta-c cursor-p" onClick={
            () => this.showModal('cancelShareModal',record.groupId, record.toId )
          }>
            <img src={cancelIcon} alt="" />
          </div>
        )
      }
    ]

    return (
      <MaterialModal
        className="pgx-report-share"
        title="报告共享"
        visible={visible}
        footer={false}
        width={500}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={() => onCancel("shareModalShowed")}
        />
        <Row type="flex" justify='start' align='middle' className='subtitle'>
          <i></i>
          <MaterialFormItem
            className="share-item"
            labelText="共享给"
            labelWidth={34}
            justify="space-between"
          >
            <Select
              combobox
              style={{ width: 345 }}
              value={username}
              onChange={this.shareInputChange}
              placeholder="请输入用户名或手机号码"
            >
              <Option value="jbsx">jbsx</Option>
            </Select>
            <PButton
              type="green"
              className="share-btn"
              onClick={() => action(username, this.clearUsername)}
            >
              共享
            </PButton>
          </MaterialFormItem>
        </Row>
        <Row type="flex" justify='start' align='middle' className='subtitle current-share-subtitle'>
          <i></i>
          <Row type="flex" justify='start' align='middle' className="content">
            当前正在共享的
            <div className="line"></div>
          </Row>
        </Row>
        <Table
          columns={columns}
          rowKey={record => record.id + record.name}
          scroll={{ y: 312 }}
          dataSource={shareList.slice()}
          pagination={false}
        />

        {cancelShareModal &&
          <MaterialModal
            className="pgs-datamanage-delete-modal"
            title="取消分享确认"
            visible={true}
            action={() => {
              cancelShare(groupId, toId, 'toId')
                .then(
                  res => { 
                    this.closeModal("cancelShareModal") 
                  },
                )
            }}
            buttonText="确认"
            buttonType="danger"
          >
            <img
              className="pgx-modal-close"
              src={closeIcon}
              alt="关闭对话框"
              onClick={() => this.closeModal("cancelShareModal")}
            />
            <Row className="warning-line1" type="flex" justify="center" align="middle" gutter={8}>
              <img src={deleteWarningIcon} alt="" />
              <div>您确认取消共享数据吗？</div>
            </Row>
          </MaterialModal>
        }
      </MaterialModal>
      
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/ShareModal/index.js